import { render, staticRenderFns } from "./Single.vue?vue&type=template&id=9e528580&"
import script from "./Single.vue?vue&type=script&lang=ts&"
export * from "./Single.vue?vue&type=script&lang=ts&"
import style0 from "./Single.vue?vue&type=style&index=0&id=9e528580&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports